import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_REQUESTER](state, data) {
    state.allRequesters = data
  },
}
